import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  setupWrapper: {
    backgroundColor: palette.shades[200],
    marginTop: '18px',
    padding: '18px 24px'
  },
  qrWrapper: {
    backgroundColor: '#FFFFFF',
    display: 'inline-block',
    marginBottom: '18px',
    padding: '12px'
  },
  secret: {
    fontFamily: 'monospace',
    letterSpacing: '1px',
    overflowWrap: 'anywhere',
    wordBreak: 'break-all'
  },
  codeField: {
    marginTop: '18px',
    maxWidth: '220px'
  },
  actions: {
    alignItems: 'center',
    display: 'flex',
    gap: '12px',
    marginTop: '18px'
  }
}));
export default useStyles;